import patternize from '@formatters/patternize';

export const CODE_FORMAT = '##';
export const NUMBER_FORMAT = '####-####';
export const CELLPHONE_NUMBER_FORMAT = '#####-####';

export const CODE_REGEX = /^[1-9][0-9]$/;
export const NUMBER_REGEX = /^[1-9]{1}[0-9]{3,4}-[0-9]{4}$/;
export const CELLPHONE_NUMBER_REGEX = /^\9[0-9]{4}-[0-9]{4}$/;
export const PHONE_REGEX = /^\([1-9][0-9]\) [1-9]{1}[0-9]{3,4}-[0-9]{4}$/;
export const CELLPHONE_REGEX = /^\([1-9][0-9]\) \9[0-9]{4}-[0-9]{4}$/;

export const PHONE_FORMAT = `(${CODE_FORMAT}) ${NUMBER_FORMAT}`;
export const CELLPHONE_FORMAT = `(${CODE_FORMAT}) ${CELLPHONE_NUMBER_FORMAT}`;

export default function phone(value = '') {
  if (['', undefined, null].includes(value)) {
    return false;
  }

  const formatted = patternize(value, {
    format: PHONE_FORMAT,
    bigFormat: CELLPHONE_FORMAT,
  });

  if (PHONE_REGEX.test(formatted)) {
    return false;
  }

  return true;
}

phone.message = function message(value, options = {}) {
  return options.message || 'precisa ser um telefone válido';
};
